import React, { useState } from 'react';
import { ChatCircle, Users } from '@phosphor-icons/react';
import ChatContainer from './ChatContainer';
import StaffParentSelector from './StaffParentSelector';
import GroupChatPanel from './GroupChatPanel';
import LockedFeature from '../LockedFeature';
import './ChatTabs.css';

/**
 * StaffChat - messaging surface for staff roles without a "my classes"
 * concept (HR, Nurse, Registrar, Storekeeper). Search any student, message
 * their parent. Same shared core as Teacher/Parent chat — see ChatContainer.
 *
 * A tab switcher above it toggles to GroupChatPanel (staff-to-staff group
 * conversations) — a separate, self-contained component with its own state.
 * ChatContainer itself is untouched; this only wraps/toggles at this level.
 */
const StaffChat = () => {
  const [activeTab, setActiveTab] = useState('direct');

  return (
    <div className="chat-tabs-wrapper">
      <div className="chat-tabs-bar">
        <button
          className={`chat-tab-btn ${activeTab === 'direct' ? 'active' : ''}`}
          onClick={() => setActiveTab('direct')}
        >
          <ChatCircle size={16} /> Direct Messages
        </button>
        <LockedFeature module="comms_plus">
          <button
            className={`chat-tab-btn ${activeTab === 'groups' ? 'active' : ''}`}
            onClick={() => setActiveTab('groups')}
          >
            <Users size={16} /> Groups
          </button>
        </LockedFeature>
      </div>

      <div className="chat-tabs-content">
        {activeTab === 'direct' ? (
          <ChatContainer
            title="Messages to Parents"
            subtitle="Reach a parent about their child"
            userRole="staff"
            contactNoun="parent"
            recentlyMessagedStorageKey="recentlyMessagedParentsStaff"
            renderSelector={({ onSelected, onCancel }) => (
              <StaffParentSelector onSelected={onSelected} onCancel={onCancel} />
            )}
          />
        ) : (
          <GroupChatPanel />
        )}
      </div>
    </div>
  );
};

export default StaffChat;
